import React from 'react';
import type { Placement } from 'react-joyride';
import { useObservable } from 'react-use-observable';

import eduzzAccountsService from 'v2/services/eduzzAccount';

const WelcomeMessage = () => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  return (
    <>
      <>
        <b className='text-xl'>Olá {user?.name || ''}!</b> Você está no My Eduzz, a nova plataforma da Eduzz para gerir
        seu negócio online. Vem com a gente nesse tour para descobrir as principais funcionalidades que preparamos para
        você
      </>
      <div className='relative'>
        <img
          src='/img/mascote_edu_apresentando.png'
          alt=''
          aria-hidden
          className='absolute top-0 -right-32.5 z-5 block h-70 w-42.5 object-cover object-center max-sm:hidden'
        />
      </div>
    </>
  );
};
export const steps = [
  {
    target: 'body',
    content: <WelcomeMessage />,
    placement: 'center' as Placement
  },
  {
    target: '#myNotifications',
    content: 'Notificações de afiliação, mensagens e outros avisos importantes estão aqui'
  },
  {
    target: '#myProfile',
    content:
      'Aqui você encontra seu Perfil, nesse menu é possível alterar seus dados cadastrais, consultar suas compras e alterar suas formas de pagamento'
  }
];
